// extracted by mini-css-extract-plugin
module.exports = {"bold":"aga_wy","filterButton":"aga_aaf","icon":"aga_b8"};